var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_1","name":"1","data-vcode":"NUMBER_1"}},[_c('div',{staticClass:"digit"},[_vm._v("1")]),_c('div',{staticClass:"letters",attrs:{"aria-hidden":"true"}},[_vm._v(" ")])])
}]

export { render, staticRenderFns }